import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import SubjectLibrary from './pages/SubjectLibrary';
import SectionPage from './pages/SectionPage';
import TopicPage from './pages/TopicPage';
import Bookmarks from './pages/Bookmarks';
import { ThemeProvider } from './lib/theme';

function App() {
  useEffect(() => { document.title = 'ThetaLabs — JEE Advanced Previous Year Questions'; }, []);
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/subject/:subjectId" element={<SubjectLibrary />} />
            <Route path="/subject/:subjectId/section/:sectionId" element={<SectionPage />} />
            <Route path="/subject/:subjectId/section/:sectionId/topic/:topicId" element={<TopicPage />} />
            <Route path="/bookmarks" element={<Bookmarks />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
